import {
  AgGridTable,
  type AgGridTableProps,
} from '@shared/components/ui/AgGridTable';
import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';
import { StockMovementsModel } from '../../models/StockMovements';

type SortingConfig = NonNullable<AgGridTableProps['sorting']>;

interface TableProps {
  stockmovements: StockMovementsModel[];
  isLoading?: boolean;
  isFetching?: boolean;
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: SortingConfig | null;
  onSortingChange?: (sorting: SortingConfig | null) => void;
  total?: number;
}

export const StockMovementsAgGridTable = ({
  stockmovements,
  isLoading = false,
  isFetching = false,
  className,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
}: TableProps) => {
  const { allColumnDefs } = useAgGridColumns();
  const columnDefs = useMemo<ColDef<StockMovementsModel>[]>(
    () => allColumnDefs,
    [allColumnDefs]
  );

  return (
    <div
      className={`w-full transition-opacity duration-300 ${
        isFetching && !isFetchingNextPage
          ? 'opacity-50 pointer-events-none'
          : ''
      }`}
    >
      <AgGridTable
        data={stockmovements}
        columnDefs={columnDefs}
        className={`rounded-lg shadow-sm ${className ?? ''}`.trim()}
        height="calc(100vh - 200px)"
        rowHeight={50}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
        sorting={sorting}
        onSortingChange={onSortingChange}
        suppressCellFocus={true}
      />
    </div>
  );
};
